import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CLOSE } from "../../../assets";
import clsx from "clsx";
import ButtonV2 from "../buttonV2";
import useDropdown from "../../../utils-func/functions/usedropdown";
import { useQuery } from "react-query";
import {
  getJudicialDivisionById,
  getLocalGovernment,
  getStates,
} from "../../../Services/services";

import moment from "moment";
import { SearchHistoryTypes } from "../../../types";

function CaseDetailsModal({
  open,
  close,
  caseDetails,
}: {
  open: boolean;
  close: () => void;
  caseDetails: SearchHistoryTypes | null;
}) {
  const { data: judicialDivision } = useQuery(
    ["division", caseDetails?.judicial_division?.id],
    () => getJudicialDivisionById(Number(caseDetails?.judicial_division_id)),
    {
      refetchOnWindowFocus: false,
      enabled: open || !!caseDetails?.judicial_division?.id,
    },
  );
  const { data: states } = useQuery("states", getStates, {
    refetchOnWindowFocus: false,
    enabled: open,
  });
  const { data: lga } = useQuery(["lga", 1], () => getLocalGovernment(1), {
    enabled: open,
  });

  return (
    <>
      <div
        className={`w-full h-full fixed ${
          open ? "block" : "hidden"
        } top-0 left-0 bg-black flex items-center justify-center bg-opacity-50 z-[999]`}
      >
        {open && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="w-[600px] bg-white rounded-xl shadow-xl right-6 z-50"
          >
            <div className="w-full flex items-center justify-between bg-lightGold rounded-xl p-5">
              <h2 className="text-[16px] font-semibold text-[#2A2E34]">
                View Details -{" "}
                <span className="text-[16px] font-semibold text-globalGold">
                  {caseDetails?.title}
                </span>
              </h2>
              <button
                onClick={close}
                className="w-[30px] h-[30px] rounded-full -mt-2 flex items-center justify-center hover:bg-gray-200"
              >
                <img src={CLOSE} className="w-[20px] h-[20px]" alt="" />
              </button>
            </div>

            <div className="p-4 w-full ">
              <div className="w-full border flex overflow-y-scroll max-h-[370px] items-start px-5 py-3 flex-col gap-y-9 border-borderColor rounded-xl">
                <div className="flex flex-col gap-y-5 items-start">
                  <span className="text-sm font-semibold text-globalGold">
                    {"Property Details".toUpperCase()}
                  </span>
                  <div className="grid grid-cols-2 gap-6">
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Property Title
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.title}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Title Number
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.title_number}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Survey Plan Number
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.survey_plan_number}
                      </span>
                    </div>
                    {/* <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Property Owner
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.owner_name}
                      </span>
                    </div> */}
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Location
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.address}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        State
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {states?.[0]?.name}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Local Government Area
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {
                          lga?.data?.find(
                            (item: { id: number; name: string }) =>
                              item.id === Number(caseDetails?.lga_id),
                          )?.name
                        }{" "}
                        {/* <span className="text-globalGold">
                          (ID:{caseDetails?.lga_id})
                        </span> */}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Parties Involved
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.parties}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Description of Properties
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.description_of_properties}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-y-5 items-start">
                  <span className="text-sm font-semibold text-globalGold">
                    {"Case Details".toUpperCase()}
                  </span>
                  <div className="grid grid-cols-2 gap-6">
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Suit Number
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.suit_number}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Nature of Dispute
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.nature_of_case}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Court Details
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.court_details}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Judicial Division
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {judicialDivision?.name}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Status
                      </span>
                      <div
                        className={clsx(
                          "w-fit h-full flex items-center gap-x-1 p-2 rounded-lg bg-[#00AD201A]",
                          caseDetails?.status === "pending" && "bg-[#e3e3a7]",
                        )}
                      >
                        <div
                          className={clsx(
                            "w-[5px] h-[5px] rounded-full bg-[#00A63E]",
                            caseDetails?.status === "pending" && "bg-[#ADAD00]",
                          )}
                        />
                        <span
                          className={clsx(
                            "text-xs font-medium text-[#00A63E]",
                            caseDetails?.status === "pending" &&
                              "text-[#ADAD00]",
                          )}
                        >
                          {caseDetails?.status}
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Date of Commencement
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {moment(caseDetails?.date_of_commencement).format(
                          "MM/d/YYYY",
                        )}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Date of Disposal
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.date_of_disposal
                          ? moment(caseDetails?.date_of_disposal).format(
                              "MM/d/YYYY",
                            )
                          : "N/A"}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Subject Matter
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.subject_matter}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-y-5 items-start">
                  <span className="text-sm font-semibold text-globalGold">
                    {"system details".toUpperCase()}
                  </span>
                  <div className="grid grid-cols-2 gap-6">
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Case ID
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {caseDetails?.id}
                      </span>
                    </div>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Created At
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {moment(caseDetails?.created_at).format("MM/d/YYYY")}
                      </span>
                    </div>

                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-primary-50">
                        Last Updated
                      </span>
                      <span className="text-sm font-medium text-customDark">
                        {moment(caseDetails?.updated_at).format("MM/d/YYYY")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-end justify-end gap-x-3 p-8">
              <ButtonV2
                title={"Close"}
                btnStyle={"w-fit h-fit  px-7 py-2 rounded-xl bg-globalGold"}
                textStyle={"text-sm font-medium text-white "}
                handleClick={close}
              />
            </div>
          </motion.div>
        )}
      </div>
    </>
  );
}

export default CaseDetailsModal;
